import { all, takeLatest, call, put } from 'redux-saga/effects';

import { OPEN, PICKED, ON_GOING } from '@coconut/constants/questions';
import setPageTitleIcon from '@coconut/utils/setPageTitleIcon';

import {
  types,
  fetchActiveQuestionsSuccess,
  fetchActiveQuestionsFailed,
  cancelQuestionSuccess,
  cancelQuestionFailure,
  fetchNonLoginQuestionsSuccess,
  fetchNonLoginQuestionsFailed,
} from '../redux/activeQuestions';

import { updateCompletedQuestionsCount } from '../redux/completedQuestions';
import * as apis from '../apis/questions';
import * as cancelApis from '@coconut/services/apis/cancelQuestion';
import { fetchQuestionQuota } from '@coconut/services/redux/questionQuota';
import { getCapitalizedRegionLang } from '@coconut/utils/langParser';

function* fetchActiveQuestionsFlow(action) {
  const { userId } = action.payload;

  try {
    const response = yield call(apis.fetchQuestions, {
      userId,
      statuses: [OPEN, PICKED, ON_GOING],
    });

    const {
      data: {
        questions,
        current_page: currentPage,
        history_question_count: questionHistoryCount,
        ongoing_question_count: count,
      },
    } = response;

    const unreadCount = questions.filter(
      (question) => !question.is_read
    ).length;
    const hasUnread = !!unreadCount;
    setPageTitleIcon(unreadCount);

    yield put(
      fetchActiveQuestionsSuccess({
        questions,
        currentPage,
        hasUnread,
        count,
      })
    );

    yield put(updateCompletedQuestionsCount(questionHistoryCount));
  } catch (err) {
    yield put(fetchActiveQuestionsFailed(err.message));
  }
}

function* cancelQuestionFlow(action) {
  const { lang, userId, questionId } = action.payload;

  try {
    yield call(cancelApis.cancelQuestion, {
      lang: getCapitalizedRegionLang(lang),
      userId,
      questionId,
    });

    yield put(cancelQuestionSuccess(questionId));
    // get latest question quota.
    yield put(fetchQuestionQuota());
  } catch (err) {
    yield put(cancelQuestionFailure(err.message));
  }
}

function* fetchNonLoginQuestionsFlow(action) {
  const { questionId } = action.payload;

  try {
    const response = yield call(apis.fetchNonLoginQuestions, questionId);

    const { data } = response;
    const questions = [data];

    yield put(
      fetchNonLoginQuestionsSuccess({
        questions,
        count: questions.length,
      })
    );
  } catch (err) {
    yield put(fetchNonLoginQuestionsFailed(err.message));
  }
}

export default function* () {
  yield all([
    takeLatest(types.FETCH_ACTIVE_QUESTIONS, fetchActiveQuestionsFlow),
    takeLatest(types.CANCEL_QUESTION, cancelQuestionFlow),
    takeLatest(types.FETCH_NON_LOGIN_QUESTIONS, fetchNonLoginQuestionsFlow),
  ]);
}



// WEBPACK FOOTER //
// ./src/scenes/Home/services/sagas/activeQuestions.js